var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pt-20 p-5 w-11/12 overflow-y-scroll" }, [
    _c("div", { staticClass: "mt-2" }, [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col justify-between md:flex-row border-b border-gray-200 py-3"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col md:flex-row" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-64 font-bold h-10 mt-3 text-gray-800 flex justify-end"
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "flex items-center cursor-pointer",
                    attrs: { for: "togglePremiumAccess" }
                  },
                  [
                    _c("div", { staticClass: "relative" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.togglePremiumAccess,
                            expression: "togglePremiumAccess"
                          }
                        ],
                        staticClass: "hidden",
                        attrs: { id: "togglePremiumAccess", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.togglePremiumAccess)
                            ? _vm._i(_vm.togglePremiumAccess, null) > -1
                            : _vm.togglePremiumAccess
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.togglePremiumAccess,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.togglePremiumAccess = $$a.concat([
                                      $$v
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.togglePremiumAccess = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.togglePremiumAccess = $$c
                              }
                            },
                            _vm.onTogglePremiumAccess
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                      })
                    ])
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col md:flex-row border-b border-gray-200" },
        [
          _c(
            "div",
            { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
            [_vm._v("Number of Songs")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
            _c("div", { staticClass: "w-full flex-1 mx-2" }, [
              _c("div", { staticClass: "my-2 p-1 flex flex-col" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm.$v.numberOfSongs.$dirty && !_vm.$v.numberOfSongs.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Please fill Number Of Songs.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.numberOfSongs.$dirty && !_vm.$v.numberOfSongs.integer
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Value must be an integer.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.numberOfSongs.$dirty && !_vm.$v.numberOfSongs.minValue
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Value must be greater than zero.")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.numberOfSongs,
                        expression: "numberOfSongs"
                      }
                    ],
                    staticClass:
                      "block border border-grey-light w-full p-3 rounded",
                    class:
                      (_vm.$v.numberOfSongs.$dirty &&
                        !_vm.$v.numberOfSongs.required) ||
                      (_vm.$v.numberOfSongs.$dirty &&
                        !_vm.$v.numberOfSongs.integer) ||
                      (_vm.$v.numberOfSongs.$dirty &&
                        !_vm.$v.numberOfSongs.minValue)
                        ? "border-red-500"
                        : "",
                    attrs: {
                      type: "text",
                      name: "name",
                      placeholder: "Number of Songs",
                      disabled: !_vm.togglePremiumAccess
                    },
                    domProps: { value: _vm.numberOfSongs },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.numberOfSongs = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col md:flex-row border-b border-gray-200" },
        [
          _c(
            "div",
            { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
            [_vm._v("Threshold Number")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
            _c("div", { staticClass: "w-full flex-1 mx-2" }, [
              _c("div", { staticClass: "my-2 p-1 flex flex-col" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm.$v.thresholdNumber.$dirty &&
                  !_vm.$v.thresholdNumber.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Please fill Threshold Number.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.thresholdNumber.$dirty &&
                  !_vm.$v.thresholdNumber.integer
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Value must be an integer.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.thresholdNumber.$dirty &&
                  !_vm.$v.thresholdNumber.minValue
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Value must be greater than zero.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.thresholdNumber.$dirty &&
                  !_vm.$v.thresholdNumber.thresholdLower
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [
                          _vm._v(
                            "Threshold Number cannot be greater than Number of Songs"
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.thresholdNumber,
                        expression: "thresholdNumber"
                      }
                    ],
                    staticClass:
                      "block border border-grey-light w-full p-3 rounded",
                    class:
                      (_vm.$v.thresholdNumber.$dirty &&
                        !_vm.$v.thresholdNumber.required) ||
                      (_vm.$v.thresholdNumber.$dirty &&
                        !_vm.$v.thresholdNumber.integer) ||
                      (_vm.$v.thresholdNumber.$dirty &&
                        !_vm.$v.thresholdNumber.minValue)
                        ? "border-red-500"
                        : "",
                    attrs: {
                      type: "text",
                      name: "threshold",
                      placeholder: "Threshold Number",
                      disabled: !_vm.togglePremiumAccess
                    },
                    domProps: { value: _vm.thresholdNumber },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.thresholdNumber = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col md:flex-row border-b border-gray-200" },
        [
          _c(
            "div",
            { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
            [_vm._v("Reset Time")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
            _c("div", { staticClass: "w-full flex-1 mx-2" }, [
              _c("div", { staticClass: "my-2 p-1 flex flex-col" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm.$v.resetTime.h.$dirty && !_vm.$v.resetTime.h.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Please fill Reset Time Hours.")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.resetTime.mm.$dirty && !_vm.$v.resetTime.mm.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Please fill Reset Time Minutes")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.resetTime.a.$dirty && !_vm.$v.resetTime.a.required
                    ? _c(
                        "p",
                        {
                          staticClass: "text-red-500 text-xs italic text-left"
                        },
                        [_vm._v("Please fill Reset Time Period")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-start" },
                  [
                    _c("vue-timepicker", {
                      attrs: {
                        disabled: !_vm.togglePremiumAccess,
                        format: "h:mm a",
                        "hide-clear-button": "",
                        "close-on-complete": ""
                      },
                      model: {
                        value: _vm.resetTime,
                        callback: function($$v) {
                          _vm.resetTime = $$v
                        },
                        expression: "resetTime"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col md:flex-row " }, [
        _c(
          "div",
          {
            staticClass:
              "w-1/2 font-bold h-auto mt-3 text-gray-800 flex flex-row"
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "text-sm  mx-2 w-full  focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer\n                        bg-teal-700 text-teal-100\n                        hover:bg-teal-100\n                        hover:text-teal-700\n                          border duration-200 ease-in-out\n                        border-teal-600 transition",
                on: { click: _vm.save }
              },
              [_vm._v("Save\n        ")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col" }, [
      _c("h1", { staticClass: "flex text-3xl" }, [
        _vm._v("Daily Premium Access")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Toggle on daily premium access to enable daily premium restriction to free users"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-190acd78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190acd78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/DailyPremiumAccess.vue
// module id = null
// module chunks = 